var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageplacehoder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 86,
    viewBox: "0 0 200 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2702"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_74623)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 86,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Placeholder",
    opacity: 0.3,
    d: "M201.125 -19H-1.125C-2.16053 -19 -3 -16.9096 -3 -14.3309V108.331C-3 110.91 -2.16053 113 -1.125 113H201.125C202.161 113 203 110.91 203 108.331V-14.3309C203 -16.9096 202.161 -19 201.125 -19Z",
    fill: "#5378B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval 2",
    d: "M118.569 32.4259C122.236 32.4259 125.209 29.6443 125.209 26.213C125.209 22.7816 122.236 20 118.569 20C114.902 20 111.929 22.7816 111.929 26.213C111.929 29.6443 114.902 32.4259 118.569 32.4259Z",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 836",
    d: "M118.968 70.043C118.968 70.043 117.837 70.043 116.456 70.043H59.3708C57.9836 70.043 57.4555 69.1547 58.191 68.0591L86.0667 26.5369C86.8022 25.4412 88.0267 25.4352 88.7869 26.5036L113.206 61.1324",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M99.1653 70.0674C99.1653 70.0674 99.7576 69.1835 100.499 68.0768L116.586 44.0664C117.322 42.967 118.558 42.9358 119.349 44.0016L136.703 67.3833C137.492 68.4469 137.015 69.3412 135.613 69.3815L120.498 69.8157",
    fill: "#F2F6FB"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_74623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 86,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageplacehoder);
export default __webpack_public_path__ + "static/media/Imageplacehoder.76179b12f48fa2c268d194d373f3f7e8.svg";
export { ForwardRef as ReactComponent };